module.exports = __webpack_public_path__ + "img/default.09c01b13.svg";